<div class="overlay person-internal-id">
    <div class="overlay-header">
        <h2>Person Internal IDs</h2>

        <div class="close-btn">
          <button mat-icon-button (click)="modalClose()">
            <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon>
          </button>
        </div>
    </div>
    <div class="section-divider"></div>
    
    <div class="container">
    <div class="row">
        
        <div class="col-md-12 pos-relative">
        <div class="current-coverage-content">                  
        
                    <f-alert variant="warning" *ngIf="idMappingArr.length === 0">
                        {{noDataMsg}}
                    </f-alert>

                     <!-- Code for CCR1-14943 start -->
                    <!-- <h6>Person Internal IDs </h6> -->
                    
                    <div class="subscription-table " *ngIf="idMappingArr.length !== 0">
                        <div class=" subscription-row ">
                            <span class="col-md-3 subscription-label">Platform Type</span>
                            <span class="col-md-3 subscription-label">Domain</span>
                            <span class="col-md-3 subscription-label">Role Type</span>
                            <span class="col-md-3 subscription-label">Person Internal ID</span>
                        </div>
                        <div *ngFor="let item of idMappingArr" class="subscription-row column-data">
                            <span class="col-md-3 subscription-value">{{item.platformType}}</span>
                            <span class="col-md-3 subscription-value">{{item.domains}}</span>
                            <span class="col-md-3 subscription-value">{{ showRoleTypeInFullForm(item.roleType)}}</span>
                            <span class="col-md-3 subscription-value">{{item.platformInternalId}}</span>
                        </div>
                    </div>

                    <!-- Code for CCR1-14943 start -->
                     <!-- <h6 class="sub_header">Dummy table header </h6>
                     <div class="subscription-table " *ngIf="idMappingArr.length !== 0">
                        <div class=" subscription-row ">
                            <span class="col-md-3 subscription-label">Platform Type</span>
                            <span class="col-md-3 subscription-label">Domain</span>
                            <span class="col-md-3 subscription-label">Role Type</span>
                            <span class="col-md-3 subscription-label">Person Internal ID</span>
                        </div>
                        <div *ngFor="let item of idMappingArr" class="subscription-row column-data">
                            <span class="col-md-3 subscription-value">{{item.platformType}}</span>
                            <span class="col-md-3 subscription-value">{{item.domains}}</span>
                            <span class="col-md-3 subscription-value">{{ showRoleTypeInFullForm(item.roleType)}}</span>
                            <span class="col-md-3 subscription-value">{{item.platformInternalId}}</span>
                        </div>
                    </div> -->



                    <div class="button-controls" >
                        <f-button text="Close" title="close" variant="progressive"  (buttonClicked)="modalClose()">
                        </f-button>
                    </div>



                    </div>

        </div>
    </div>
    </div>
</div>
